require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/modules/es7.symbol.async-iterator.js